import React, { useEffect, useState } from 'react';
import { Route, Switch, useRouteMatch } from 'react-router';
import { useAuth } from '../../../Contexts/AuthContext';
import DashboardNav from '../DashboardNav/DashboardNav';
import OrderList from '../OrderList/OrderList';
import AddService from './AddService/AddService';
import ManageService from './ManageService/ManageService';
import Reviews from './Reviews/Reviews';

const Dashboard = () => {
    const {path} = useRouteMatch()
    const {currentUser} = useAuth()
    const [userInfo, setUserInfo] = useState(null)
    useEffect(() => {
        fetch(
            `http://localhost:5000/addUser/?email=${
                currentUser?.email
            }&admin=${false}`
        )
            .then((res) => res.json())
            .then((data) => setUserInfo(data))
    }, [currentUser])
    return (
        <section>
        <div style={{height:"10vh"}}>
        <DashboardNav userInfo={userInfo} />
        </div>
        <div style={{height: "90vh"}}>
        <Switch>
            
            <Route path="/dashboard/addService">
                <AddService />
            </Route>
            <Route path="/dashboard/reviews">
                <Reviews />
            </Route>
            <Route path="/dashboard/manageService">
                <ManageService />
            </Route>
            <Route exact path={path}>
                <OrderList/>
            </Route>
        </Switch>
        </div>
        </section>
    );
};

export default Dashboard;